<template>
  <div class="rounded-lg">
    <swiper
      v-if="offerLinks.length > 0"
      :autoplay="{
        delay: 10000,
        disableOnInteraction: false,
      }"
      :effect="'fade'"
      :loop="true"
      :pagination="{
        clickable: true,
        type: 'bullets',
      }"
      class="ratio21 rounded-xl w-full"
    >
      <swiper-slide class="" v-for="link in offerLinks" :key="link"
        ><img
          alt="promo image"
          class="object-cover w-full ratio21 bg-white"
          :src="link"
      /></swiper-slide>
    </swiper>
    <img
      v-else
      alt="promo image"
      class="object-cover w-full h-full bg-white"
      src="/img/intro/browsemenu21.jpg"
    />
  </div>
</template>

<script>
import "swiper/swiper.scss";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/pagination/pagination.scss";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, EffectFade, Pagination } from "swiper/core";
SwiperCore.use([Autoplay, EffectFade, Pagination]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    offerLinks() {
      return this.$store.state.appDetails.offers?.links ?? [];
    },
  },
};
</script>

<style scoped>
.ratio21 {
  aspect-ratio: 2/1;
}
</style>
